import useLocalStorage from '@propertypal/shared/src/hooks/useLocalStorage';
import { Property } from '@propertypal/shared/src/types/property';
import { filterPropertiesByPhase, getPropertyPhaseOptions } from '@propertypal/shared/src/utils/property/propertyPhase';
import { SORT_OPTIONS, sortProperties } from '@propertypal/shared/src/utils/property/propertySort';
import SelectInput from '@propertypal/web-ui/src/inputs/SelectInput';
import WhiteModal from '@propertypal/web-ui/src/modal/WhiteModal';
import PropertyGrid from '@propertypal/web-ui/src/property/PropertyGrid';
import React, { FunctionComponent, useMemo } from 'react';

interface Props {
  show: boolean;
  onClose: () => void;
  properties: Property[];
  phase: string;
  setPhase: (phase: string) => void;
  onFavourite?: () => (favourited: boolean, propertyId: number) => Promise<boolean>;
}

const PropertyTypesModal: FunctionComponent<Props> = (props) => {
  const [sort, setSort] = useLocalStorage<string>('PROPERTY_TYPE_SORT', 'default');

  const phaseOptions = useMemo(() => getPropertyPhaseOptions(props.properties), [props.properties]);

  const sorted = useMemo(
    () => sortProperties(filterPropertiesByPhase(props.properties, props.phase), sort),
    [props.phase, props.properties, sort],
  );

  return (
    <WhiteModal title="Property Types" show={props.show} onClose={props.onClose}>
      <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap', marginBottom: 20 }}>
        {phaseOptions.length > 0 && (
          <SelectInput
            containerStyle={{ maxWidth: 260 }}
            ariaLabel="phase"
            id="property-types-phase-select"
            testID="property-types-phase-select"
            value={props.phase}
            onChange={props.setPhase}
            options={phaseOptions}
            placeholder="Select Phase"
          />
        )}

        <SelectInput
          containerStyle={{ maxWidth: 260 }}
          ariaLabel="sort by"
          id="property-types-sort-select"
          testID="property-types-sort-select"
          value={sort}
          onChange={setSort}
          options={SORT_OPTIONS}
        />
      </div>

      <PropertyGrid containerStyle={{ padding: 0 }} properties={sorted} onFavourite={props.onFavourite} />
    </WhiteModal>
  );
};

export default PropertyTypesModal;
